import { FileText, Upload, Zap } from 'lucide-react';

export const WHATSAPP_NUMBER = '918606600912';
export const WHATSAPP_DISPLAY = '+91 86066 00912';
export const WHATSAPP_URL =
  `https://wa.me/${WHATSAPP_NUMBER}?text=` +
  encodeURIComponent('Hi Urava, I want to research:');

export function WhatsAppIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.04 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982 1-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884zM20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.652a11.882 11.882 0 005.7 1.45h.005c6.582 0 11.945-5.335 11.948-11.893a11.821 11.821 0 00-3.467-8.456z" />
    </svg>
  );
}

export function FloatingWhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-track="whatsapp-floating"
      aria-label="Chat with Urava on WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex items-center space-x-2 bg-[#25D366] hover:bg-[#1ebe57] text-white font-semibold px-4 py-3 rounded-full shadow-2xl transition-transform hover:scale-105 press"
    >
      <WhatsAppIcon className="h-5 w-5" />
      <span className="hidden sm:inline text-sm">Chat on WhatsApp</span>
    </a>
  );
}

export const steps = [
  {
    number: '01',
    title: 'Ask a question or upload a document',
    description: 'Type or dictate your legal question in plain English, Hindi or Malayalam — or upload a charge sheet, FIR, or legal notice in any Indian language, including scanned PDFs.',
    icon: Upload,
  },
  {
    number: '02',
    title: 'AI researches for you',
    description: 'Urava searches Supreme Court and High Court judgments, statutes, BNS/BNSS/BSA provisions, and live legal sources — then verifies every citation link.',
    icon: Zap,
  },
  {
    number: '03',
    title: 'Get the memo — or the draft',
    description: 'A structured legal memorandum with cited cases and counter-arguments, or a court-ready draft with its statutory deadlines checked. Download as PDF or Word.',
    icon: FileText,
  },
];
